import React from 'react';
import PropTypes from 'prop-types';
import { loadScript } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';

class Weibo extends React.PureComponent {
    static propTypes = {
        uid: PropTypes.string,
    };

    createMarkup = () => {
        const { uid } = this.props;

        return {
            __html: `<wb:follow-button
                uid=${uid}
                style="margin-top: 30px; display: block;"
                type="red_2"
                width="130"
                height="24"
            />`,
        };
    };

    componentDidMount() {
        loadScript('//tjs.sjs.sinajs.cn/open/api/js/wb.js');
    }

    render() {
        return <div dangerouslySetInnerHTML={this.createMarkup()} />;
    }
}

export default errorBoundary(Weibo);
